// src/components/practice/tasks/writing/layouts/OsdB1EmailLayout.jsx
import React from 'react';
import { marked } from 'marked';

const OsdB1EmailLayout = ({ inputContent, task, guidingPoints }) => {
    return (
        <>
            {/* Email Layout */}
            <div className="my-6">
                {/* Email Header */}
                <div className="bg-gray-100 border border-gray-400 px-4 py-2 text-sm">
                    <div className="flex items-center mb-1">
                        <span className="font-semibold mr-2">Von:</span>
                        <span>{task.emailFrom || 'sender@example.com'}</span>
                    </div>
                    <div className="flex items-center">
                        <span className="font-semibold mr-2">Betreff:</span>
                        <span>{task.emailSubject || 'Email Subject'}</span>
                    </div>
                </div>

                {/* Email Body */}
                <div className="border border-gray-400 border-t-0 p-6 bg-white min-h-[200px]">
                    <div className="prose prose-sm max-w-none whitespace-pre-wrap text-gray-800 leading-relaxed"
                         dangerouslySetInnerHTML={{ __html: marked.parse(inputContent) }} />
                </div>
            </div>

            {/* Guiding Points - OSD B1 special format */}
            {guidingPoints && guidingPoints.length > 0 && (
                <div className="my-6">
                    <p className="text-gray-800 mb-3">
                        Schreiben Sie {task.emailFrom ? task.emailFrom.split('@')[0] : 'eine Person'} ein E-Mail, das folgende Punkte enthält:
                    </p>
                    <ul className="list-disc ml-6 space-y-2 text-gray-700">
                        {guidingPoints.map((point, index) => (
                            <li key={index} className="pl-2">{point.text || point}</li>
                        ))}
                    </ul>
                </div>
            )}

            {/* Special instructions */}
            <div className="my-6 text-sm text-gray-700">
                <p>
                    Schreiben Sie eine <strong>Anrede</strong>, eine passende <strong>Einleitung</strong> und einen passenden <strong>Schluss</strong>.
                </p>
            </div>
        </>
    );
};

export default OsdB1EmailLayout;